export const placeholderImageUrl =
	"https://cdn.images.slfinpub.aws.porsche.cloud/b4eec163-00b4-40d6-9bd1-ca41f1de0eef/960x720"
